module.exports = __webpack_public_path__ + "assets/img/jyz.ec503693.png";